export const regexStartsWithNoneOf = (strings: string[]): string => {
  return `^(?!(${strings.join('|').toUpperCase()}|${strings.join('|').toLowerCase()}).)`;
};
